import { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const Button: ButtonDesignTokens = {
  root: {
    borderRadius: '0.5rem',
  },
  colorScheme: {
    light: {
      outlined: {
        primary: {
          borderColor: '{primary.600}',
          color: '{primary.600}',
          hoverBackground: '{primary.100}',
        },
        danger: {
          borderColor: '{red.600}',
        },
        contrast: {
          hoverBackground: '{green.50}',
          color: '{surface.700}',
        },
      },
      text: {
        primary: {
          color: '{primary.600}',
          hoverBackground: '{primary.100}',
        },
      },
      link: {
        color: '{primary.600}',
        hoverColor: '{primary.700}',
      },
    },
  },

  css: () => `
    .p-button {
      font-size: 1rem;
    }
    .p-button-sm {
      font-size: 0.875rem;
    }
    .p-button-lg {
      font-size: 1.25rem;
    }
    .pi {
    font-size: 1rem;
    }
    .p-button-link {
      padding: 0 0.0625rem;
      border-radius: 0;
    }
    `,
};
